import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../actions/appusers";
import { Mixpanel } from "../../mixpanel";

import RTMService from "../../services/rtm";

import _, { update } from "lodash";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import TextField from "@material-ui/core/TextField";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Switch from "@material-ui/core/Switch";
import AppFrame from "../Appframe/AppFrame";
import Title from "../../components/common/Title";
import colors from "../../styles/colors";
import { colorsV2 } from "../../styles/colors";
import layout from "../../styles/layout";

import Dialog from "material-ui/Dialog";
import MenuItem from "material-ui/MenuItem";
import FlatButton from "material-ui/FlatButton";
import SelectField from "material-ui/SelectField";
import DatePicker from "material-ui/DatePicker";
import WrapDialogue from "../../components/common/WrapDialogue";
import "../../resources/styles/ManageUsers.css";

import CalIcon from "material-ui/svg-icons/action/date-range";
import CancelIcon from "material-ui/svg-icons/navigation/cancel";
import { Checkbox } from "@material-ui/core";
import PatientRTMRow from "../../components/rtm/PatientRTMRow";

class ManageRTMPatients extends Component {
  constructor(props) {
    super(props);

    this.interactionDiag = React.createRef();

    let appId = props.match.params.appId;
    let appInfo = this.props.apps.appInfos[appId];
    this.state = {
      appId,
      appInfo,
      data: [],
      appUsers: [],
      modalOpen: false,
      reportModalOpen: false,
      width: 0,
      height: 0,
      anchorEl: null,
      showAll: false,
      selectedStartDate: null,
      selectedEndDate: null,
      includePatientActivity: true,
      includeProviderActivity: true,
    };

    this.updateRow = this.updateRow.bind(this);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  updateRow(cappId, timeSpent) {
    let updatedData = this.state.data.map((row) => {
      if (row.customAppId === cappId) {
        const updatedTimeSpent = row.minutesInChartThisMonth + timeSpent;
        row.minutesInChartThisMonth = updatedTimeSpent;
      }
      return row;
    });
    this.setState({ data: updatedData });
  }

  componentDidMount() {
    Mixpanel.track("View RTM page", {
      "Channel Name": this.state.appInfo ? this.state.appInfo.appName : "",
      "Channel ID": this.state.appId,
      "App Type": this.state.appInfo ? this.state.appInfo.appType : "",
    });
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener(
      "resize",
      this.updateWindowDimensions.bind(this)
    );
  }

  componentWillMount() {
    RTMService()
      .getRTMList(this.state.appId, this.props.user.userId)
      .then((response) => {
        this.setState({ data: response.rtmRecordList });
      });
  }

  componentWillReceiveProps(nextProps) {
    let appInfo = nextProps.apps.appInfos[this.state.appId];
    if (appInfo) {
      this.setState({ appInfo });
    }
  }

  handleMoreOptions = (event) => {
    event.stopPropagation();
    this.setState({
      anchorEl: event.currentTarget,
    });
  };

  getStatusForUser = (row) => {
    const now = new Date();

    if (row.wasBilledFor) {
      return "Complete - No Action Needed";
    } else if (!row.hasPatientActivity) {
      return "Call inactive patient - account setup";
    } else if (
      row.hasPatientActivity &&
      this.olderThanSixteenDays(row.dateOfEval)
    ) {
      return "Bill for 98975";
    } else if (row.userInfo.profilePhotoUrl !== undefined) {
      return "Call active patient - check in";
    } else {
      return "No Action Needed";
    }
  };

  completeBilling = (
    customAppId,
    claimDate,
    sevenFive,
    sevenSeven,
    eightOne,
    eightZero
  ) => {
    if (sevenFive) {
      RTMService()
        .inesrtBillingInfo(customAppId, "98975", claimDate)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
    if (sevenSeven) {
      RTMService()
        .inesrtBillingInfo(customAppId, "98977", claimDate)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
    if (eightZero) {
      RTMService()
        .inesrtBillingInfo(customAppId, "98980", claimDate)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }
    if (eightOne) {
      RTMService()
        .inesrtBillingInfo(customAppId, "98981", claimDate)
        .then(() => {})
        .catch((err) => {
          console.log(err);
        });
    }

    RTMService()
      .markCustomAppBilledFor(customAppId, this.state.userId)
      .then(() => {
        const updatedData = this.state.data.map((row) => {
          if (row.customAppId === customAppId) {
            row.wasBilledFor = true;
            if (sevenFive) {
              row.sevenFiveBilledFor = true;
            }
            if (sevenSeven) {
              row.sevenSevenBilledFor = true;
            }
            if (eightZero) {
              row.eightZeroBilledFor = true;
            }
            if (eightOne) {
              row.eightOneBilledFor = true;
            }
          }
          return row;
        });

        this.setState({ data: updatedData });
      })
      .catch((err) => {
        alert(err);
      });
  };

  removeRTMPatient = (capp_id) => {
    RTMService()
      .removePatientFromRTM(capp_id, this.state.userId)
      .then(() => {
        const updatedData = this.state.data.filter((row) => {
          return row.customAppId !== capp_id;
        });

        this.setState({ data: updatedData });
      })
      .catch((err) => {
        alert(err);
      });
  };

  padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  formatDate(dt) {
    const date = new Date(dt);
    return [
      this.padTo2Digits(date.getMonth() + 1),
      this.padTo2Digits(date.getDate()),
      date.getFullYear(),
    ].join("/");
  }

  olderThanSixteenDays = (date) => {
    const today = new Date();
    const priorDate = new Date(new Date().setDate(today.getDate() - 16));
    return new Date(date) < priorDate;
  };

  render() {
    let numUsers = _.size(this.state.appUsers);
    let targetDevice = "desktop";
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      targetDevice = "mobile";
    }

    return (
      <AppFrame
        auth={this.props.auth}
        header={"Manage RTM"}
        optionsType={"RTM"}
        whiteLabelSettings={this.props.whiteLabelSettings}
      >
        <Title
          whiteLabelSettings={this.props.whiteLabelSettings}
          goBack={() => this.props.history.goBack()}
        />
        <div style={layout.common.filterRow}>
          <div style={layout.common.searchField}>
            <TextField
              id="filled-full-width"
              label="Search"
              style={{ margin: 8 }}
              placeholder="Search By Name"
              fullWidth
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={this.state.searchText}
              onChange={(e) => {
                this.setState({ searchText: e.target.value });
              }}
            />
            <IconButton
              color="primary"
              aria-label="Clear Search"
              component="span"
              onClick={() => this.setState({ searchText: "" })}
              style={layout.common.searchFieldCancel}
            >
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div>
          {this.state.data
            .filter((row) => {
              const fName =
                (row.userInfo.firstName ? row.userInfo.firstName : "") +
                " " +
                (row.userInfo.lastName ? row.userInfo.lastName : "");
              return this.state.searchText
                ? fName
                    .toLowerCase()
                    .includes(this.state.searchText.toLowerCase())
                : true;
            })
            .sort((a, b) => {
              if (new Date(a.dateOfEval) < new Date(b.dateOfEval)) {
                return -1;
              }
              if (new Date(b.dateOfEval) < new Date(a.dateOfEval)) {
                return 1;
              }

              if (
                b.userInfo.lastName.toLowerCase() <
                a.userInfo.lastName.toLowerCase()
              ) {
                return 1;
              }
              if (
                !a.userInfo.lastName ||
                !b.userInfo.lastName ||
                !a.userInfo.firstName ||
                !b.userInfo.firstName
              ) {
                return 0;
              }
              if (
                a.userInfo.lastName.toLowerCase() <
                b.userInfo.lastName.toLowerCase()
              ) {
                return -1;
              }
              if (
                b.userInfo.lastName.toLowerCase() <
                a.userInfo.lastName.toLowerCase()
              ) {
                return 1;
              }
              // a must be equal to b
              if (
                a.userInfo.firstName.toLowerCase() <
                b.userInfo.firstName.toLowerCase()
              ) {
                return -1;
              }
              if (
                b.userInfo.firstName.toLowerCase() <
                a.userInfo.firstName.toLowerCase()
              ) {
                return 1;
              }
              return 0;
            })
            .map((row, idx) => {
              return (
                <PatientRTMRow
                  {...row}
                  providerUserId={this.props.userId}
                  completeBilling={this.completeBilling}
                  removeRTMPatient={() => {
                    this.removeRTMPatient(row.customAppId);
                  }}
                  updateRow={this.updateRow}
                  appInfo={this.state.appInfo}
                  patientUserId={row.userId}
                />
              );
            })}
        </div>
        <div></div>
      </AppFrame>
    );
  }
}

function mapStateToProps({ user, apps, appusers, whiteLabelSettings }) {
  return {
    user,
    userId: user.userId,
    apps,
    appusers,
    whiteLabelSettings,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageRTMPatients);



// WEBPACK FOOTER //
// ./src/layout/rtm/ManageRTMPatients.js